import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import type { BookingRequest } from '../types/booking';
import { BookingForm } from './BookingForm';
interface ContactProps {
  bookingRequest: BookingRequest | null;
}
export function Contact({
  bookingRequest
}: ContactProps) {
  const {
    t
  } = useLanguage();
  const info = t.contact.info;
  const rows: {
    label: string;
    value: string;
    href?: string;
  }[] = [{
    label: info.phone,
    value: business.phoneDisplay,
    href: business.phoneHref
  }, {
    label: info.whatsapp,
    value: info.whatsappValue,
    href: business.whatsapp
  }, {
    label: info.location,
    value: info.locationValue
  }, {
    label: info.availability,
    value: info.availabilityValue
  }];
  return <section id="contact" aria-labelledby="contact-title" className="on-dark scroll-mt-20 bg-charcoal py-24 text-cream md:py-32" data-id="element-52" data-mp="ggcfxspzphpy">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-53" data-mp="bouhbbbfvt85">
        <div className="lg:col-span-5" data-id="element-54" data-mp="3jww48jtve4d1">
          <h2 id="contact-title" className="font-display text-[34px] font-medium tracking-[-0.015em] text-white md:text-[44px]" data-id="element-55" data-mp="3jxxgusqjaywv">
            {t.contact.title}
          </h2>
          <p className="mt-4 font-serif text-[22px] italic text-cream/85" data-id="element-56" data-mp="3f4utx3g9inpn">{t.contact.sub}</p>

          <dl className="mt-12" data-id="element-57" data-mp="3f2i7aczk7p69">
            {rows.map(r => <div key={r.label} className="grid gap-1 border-t border-white/10 py-5 last:border-b sm:grid-cols-[130px_1fr] sm:gap-6" data-id="element-58" data-mp="313ihv3483691">
                <dt className="text-[13px] font-medium text-cream/55" data-id="element-59" data-mp="2s5qaqm8nn4wq">{r.label}</dt>
                <dd className="text-[16px] text-cream" data-id="element-60" data-mp="2w58lip6rhzlu">
                  {r.href ? <a href={r.href} target={r.href.startsWith('http') ? '_blank' : undefined} rel={r.href.startsWith('http') ? 'noopener noreferrer' : undefined} className="underline decoration-white/20 underline-offset-4 transition-colors duration-200 hover:text-violet-light hover:decoration-violet-light" data-id="element-61" data-mp="qcinmqmsvj0a">
                      {r.value}
                    </a> : r.value}
                </dd>
              </div>)}
          </dl>
          <p className="mt-8 flex items-center gap-3 text-[15px] text-cream/80" data-id="element-62" data-mp="2m10i5mlhtlsp">
            <span aria-hidden="true" className="h-2 w-2 rounded-full bg-sage" data-id="element-63" data-mp="2hzyhr2fub3p5" />
            {info.response}
          </p>
        </div>

        <div className="lg:col-span-7" data-id="element-64" data-mp="2d8goz1nz09f9">
          <BookingForm request={bookingRequest} data-id="element-65" data-mp="28aoovkd69gzz" />
        </div>
      </div>
    </section>;
}